<div class="boxWhite">

  <h4>VER VIAJE</h4>

  <button class="btn btnClose">
    <img src="assets/img/icoClose.svg" (click)="close()">
  </button>

  <div class="headInfo">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>{{viaje?.servicio}}</h4>
    </div>
    <div class="item">
      <span>ID VIAJE</span>
      <p>{{viaje?.viajeCodigo}}</p>
    </div>
    <div class="item">
      <span>INICIO</span>
      <p>{{muestraHora(viaje?.fechahoraInicio)}}</p>
    </div>
    <div class="item">
      <span>ORIGEN</span>
      <p>{{viaje?.sucursalOrigen.nombre}}</p>
    </div>
    <div class="item">
      <span>SENTIDO</span>
      <p>{{viaje?.sentido}}</p>
    </div>
    <div class="item">
      <span>DESTINO</span>
      <p>{{viaje?.sucursalDestino.nombre}}</p>
    </div>
    <div class="item">
      <span>DURACIÓN</span>
      <p>{{muestraDuracion(viaje?.fechahoraInicio, viaje?.fechahoraTermino)}}</p>
    </div>
    <div class="item">
      <span>LLEGADA</span>
      <p>{{muestraHora(viaje?.fechahoraTermino)}} <span *ngIf="viaje?.fechahoraTermino">{{muestraDiferenciaHorasMinutos(viaje.fechahoraTermino, viaje.fechahoraLlegada)}}</span></p>
    </div>
    <div class="item">
      <span>ESTADO</span>
      <p><strong>{{viaje?.estado.replace('_', ' ')}}</strong></p>
    </div>
  </div>


  <div class="contBoxes">
    <div class="box paraderos">
      <div class="scrollP">
        <div class="itemP" *ngFor="let paradero of detalleViaje?.paraderos; index as i"
             [ngClass]="{'inicio': i == 0, 'visited': paradero.fechahoraEjecutada != 'null' && paradero.fechahoraEjecutada != null && i < detalleViaje?.paraderos?.length - 1,
             'noComercial': !paradero.comercial, 'active': paradero.ultimoEjecutado, 'final': i == detalleViaje?.paraderos?.length - 1,
             'hidden': !paradero.comercial && i != 0 && detalleViaje.paraderos[i - 1].seco == false}">
          <div class="nombre">
            <p>{{paradero.nombre}}</p>
            <span *ngIf="i == 0">(Inicio: {{muestraHora(paradero.fechahoraPlanificada)}})</span>
            <span *ngIf="i == detalleViaje?.paraderos?.length - 1">
              (Duración: {{muestraDuracion(detalleViaje?.paraderos[0].fechahoraPlanificada, detalleViaje?.paraderos[detalleViaje?.paraderos.length - 1].fechahoraPlanificada)}})
            </span>
            <p class="servicio" *ngIf="i < detalleViaje?.paraderos?.length - 1 && paradero.optibusServicio == detalleViaje.paraderos[i + 1].optibusServicio
              && paradero.comercial">{{paradero.optibusServicio}}</p>
            <p class="servicio" *ngIf="!paradero.comercial && i != detalleViaje?.paraderos?.length - 1">VIAJE NO COMERCIAL</p>
          </div>
          <div class="date">
            <div class="hora">{{muestraHora(paradero.fechahoraPlanificada)}}
              <ng-template #t [ngTemplateOutlet]="t"
                           let-a [ngTemplateOutletContext]="{ $implicit: muestraDiferenciaHorasMinutosParadero(paradero.fechahoraPlanificada, paradero.fechahoraEjecutada) }">
                  <span *ngIf="a != ''">({{a}})</span>
              </ng-template>
            </div>
            <div class="fecha">{{muestraFechaDiaMes(paradero.fechahoraPlanificada)}}</div>
          </div>
        </div>

        <!--<div class="itemP inicio visited comercial">
          <div class="nombre">
            <p>PARADERO INICIAL</p>
            <span>(Inicio: 18:55)</span>
            <p class="servicio">201 I</p>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>

        <div class="itemP active">
          <div class="nombre">
            <p>PARADERO 02</p>
            <p class="servicio">201 I</p>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>

        <div class="itemP">
          <div class="nombre">
            <p>PARADERO 03</p>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>

        <div class="itemP">
          <div class="nombre">
            <p>PARADERO 04</p>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>

        <div class="itemP">
          <div class="nombre">
            <p>PARADERO 03</p>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>

        <div class="itemP">
          <div class="nombre">
            <p>PARADERO 04</p>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>

        <div class="itemP final">
          <div class="nombre">
            <p>PARADERO FINAL</p>
            <span>(Duración: 2h 10m)</span>
          </div>
          <div class="date">
            <div class="hora">8.10</div>
            <div class="fecha">05 Marzo</div>
          </div>
        </div>-->
      </div>
    </div>

    <div class="box vehiculo">
      <div class="title">BUS</div>

      <div class="item">
        <span>ID BUS</span>
        <p>{{viaje?.movil?.numeroInterno}}</p>
      </div>
      <div class="item">
        <span>PATENTE</span>
        <p>{{viaje?.movil?.patente}}</p>
      </div>
      <div class="item">
        <span>TIPO DE BUS</span>
        <p>{{viaje?.movil?.tipoMovil?.codigo}}</p>
      </div>
      <div class="item">
        <span>AÑO</span>
        <p>{{viaje?.movil?.anio}}</p>
      </div>
      <div class="item">
        <span>MARCA</span>
        <p>{{viaje?.movil?.marca}}</p>
      </div>
      <div class="item">
        <span>ASIENTOS</span>
        <p>{{viaje?.movil?.tipoMovil?.asientos}}</p>
      </div>
      <div class="item">
        <span>COMBUSTIBLE I.</span>
        <p>{{detalleViaje?.movil?.estadoInicio?.capacidadPorcentaje}}%</p>
      </div>
      <div class="item">
        <span>KILOMETRAJE</span>
        <p>{{detalleViaje?.movil?.estadoInicio?.kilometraje}}</p>
      </div>
      <div class="item doble">
        <span>% COMBUSTIBLE / BATERÍA ACTUAL</span>
        <p>{{detalleViaje?.movil?.estadoActual?.capacidadPorcentaje}}%</p><!-- solo poner clase cuando se da acción terminado el viaje-->
      </div>

      <!-- Esto se comenta xq en reunion JP indica q aqui viaje siempre esta en curso y no en estoa estados
      <div class="boxAccion item doble" style="color: var(--red)">
        <img src="assets/img/icoDieselRed.svg"> EN CARDA DE COMBUSTIBLE / ENERGÍA
      </div>-->


    </div>

    <div class="box conductor">
      <div class="title">CONDUCTOR
        <!--CON-1057: el tooltip va en el span porque un boton deshabilitado no recibe eventos de mouse-->
        <span *ngIf="tienePermisoImprimirVoucherRuta()" [tooltip]="tooltipImprimirVoucherRuta">
          <button class="btn btnBlack" [disabled]="procesandoPdf || !viajeConfirmado" (click)="getRutaViajePDF()">
            <img src="assets/img/icoPrint.svg" >
          </button>
        </span>
      </div>

      <div class="item">
        <span>ID CONDUCTOR</span>
        <p>{{viaje?.conductor?.visibleId}}</p>
      </div>
      <div class="item">
        <span>NOMBRE CONDUCTOR</span>
        <p>{{viaje?.conductor?.nombres}} {{viaje?.conductor?.apellidoPaterno}}</p>
      </div>
      <div class="item">
        <span>RUT</span>
        <p>{{viaje?.conductor?.rut}}</p>
      </div>
      <div class="item">
        <span>CELULAR</span>
        <p>{{viaje?.conductor?.celular}}</p>
      </div>
      <div class="item">
        <span>INICIO J.</span>
        <p>{{muestraHora(viaje?.conductor?.jornadaEnCurso?.fechaHoraInicio)}}</p>
      </div>
      <div class="item">
        <span>HORAS DISPONIBLES</span>
        <p>{{muestraHorasDisponibles()}}</p>
      </div>
      <div class="item">
        <span>H.ASIGNADAS</span>
        <p>{{muestraHorasAsignadas()}}</p>
      </div>
      <div class="item">
        <span>H.H EXTRAS</span>
        <p>{{convertirMinutosEnHoras(viaje?.conductor?.jornadaEnCurso?.horasExtra)}}</p>
      </div>
      <div class="item doble">
        <span>TERMINAL CONTRATO</span>
        <p>{{viaje?.conductor?.contratoSucursal?.nombre}}</p>
      </div>


      <!-- Esto se comenta xq en reunion JP indica q aqui viaje siempre esta en curso y no en estoa estados
      <div class="boxAccion item doble">
        <img src="assets/img/icoColacion.svg"> EN COLACIÓN <span>(30M)</span>
      </div>-->

    </div>
  </div>

</div>
